import React from 'react';
import { connect } from 'react-redux'
import PortfolioData from '../../data-portfolio';
import Navigation from '../components/Navigation';
import store from '../../store';
import * as actions from '../actions';

require('../stylesheets/_all.scss');


const { func, bool } = React.PropTypes;


const MainContainer = React.createClass({
  componentDidMount() {
    const root = document.getElementById('root');
    store.dispatch(actions.requestData(PortfolioData));
  },


  render() {
		if (typeof this.props.data === 'undefined') {
			return null;
		}

    const props = this.props;

    return (
      <div className="page">
        <Navigation />
        <div id="main" className="main">
          { this.props.children }
        </div>
      </div>
    );
  }
});




/*
 * Standard Redux mapStateToProps function.
 *
 * @param {Object} state.app - The app object in the Redux store
 *
 * @return {Object} MainContainerPropsObject - Data from state mapped to the MainContainer's props
 *
 * @since 2.0.0
 */

const mapStateToProps = ({ app }) => {
  const data = app.data;
  const isFetching = app.isFetching;


  /*
   * @typedef {Object} MainContainerPropsObject
   * @property {Boolean} isFetching - Is the application in the state of fetching data
   * @property {Object} portfolio - The portfolio data from state
   */

  return {
    isFetching,
    data
  };
};


export default connect(mapStateToProps)(MainContainer);



// WEBPACK FOOTER //
// ./app/src/App/containers/MainContainer.js